"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeService = void 0;
var MAX_COUNT = 20000;
var MINUTE_CACHE_KEY_SIZE = 60 * 1000;
var DAY_CACHE_KEY_SIZE = 24 * 60 * 60 * 1000;
// toLocaleString is quite slow (upto 5ms, so we dont want to recompute it if we can help it!)
var DateTimeService = /** @class */ (function () {
    function DateTimeService() {
        this.__priority = 100;
        this.DATE_CACHE = {};
        this.DATE_TIME_CACHE = {};
        this.ISO_CACHE = {};
        this.COUNT = 0;
    }
    DateTimeService.prototype.checkReset = function () {
        this.COUNT++;
        if (this.COUNT > MAX_COUNT) {
            this.COUNT = 0;
            this.DATE_CACHE = {};
            this.DATE_TIME_CACHE = {};
            this.ISO_CACHE = {};
        }
    };
    DateTimeService.prototype.getDate = function (iso) {
        var searchString = iso.slice(0, -5) + '.000Z';
        return this.ISO_CACHE[searchString] || (this.ISO_CACHE[searchString] = new Date(searchString));
    };
    DateTimeService.prototype.getTime = function (iso) {
        return this.getDate(iso).getTime();
    };
    DateTimeService.prototype.formatDate = function (value) {
        var date = typeof (value) === 'string' ? this.getDate(value) : value;
        var dateKey = Math.floor(date.getTime() / DAY_CACHE_KEY_SIZE);
        var dateCache = this.DATE_CACHE[dateKey];
        if (dateCache != null) {
            return dateCache;
        }
        var locale = 'en-GB';
        var output = "".concat(date.toLocaleString(locale, { month: 'short', day: '2-digit' }), ", ").concat(date.toLocaleString(locale, { year: 'numeric' }));
        this.DATE_CACHE[dateKey] = output;
        this.checkReset();
        return output;
    };
    DateTimeService.prototype.formatDateTime = function (value) {
        if (value == null) {
            return '';
        }
        var date = typeof (value) === 'string' ? this.getDate(value) : value;
        var dateKey = Math.floor(date.getTime() / MINUTE_CACHE_KEY_SIZE);
        var dateCache = this.DATE_TIME_CACHE[dateKey];
        if (dateCache != null) {
            return dateCache;
        }
        var locale = 'en-GB';
        var output = this.formatDate(date) + ' ' + date.toLocaleString(locale, { hour: '2-digit', minute: '2-digit', hour12: true });
        this.DATE_TIME_CACHE[dateKey] = output;
        this.checkReset();
        return output;
    };
    DateTimeService.prototype.padNumber = function (num) {
        var norm = Math.abs(Math.floor(num));
        return (norm < 10 ? '0' : '') + norm;
    };
    DateTimeService.prototype.formatTimezoneDate = function () {
        var now = new Date();
        var tzo = -now.getTimezoneOffset();
        var dif = tzo >= 0 ? '+' : '-';
        return now.getFullYear()
            + '-' + this.padNumber(now.getMonth() + 1)
            + '-' + this.padNumber(now.getDate())
            + 'T' + this.padNumber(now.getHours())
            + ':' + this.padNumber(now.getMinutes())
            + ':' + this.padNumber(now.getSeconds())
            + dif + this.padNumber(tzo / 60)
            + ':' + this.padNumber(tzo % 60);
    };
    return DateTimeService;
}());
exports.DateTimeService = DateTimeService;
//# sourceMappingURL=date.time.service.js.map